import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { session } from 'src/environments/environment.session';
import Swal from 'sweetalert2';
import { MainService } from '../../emb/service/main.service';
import { ClerkNocService } from '../service/clerk-noc.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditorService } from '../../md/service/editor.service';
import { MainService as portalmainservice } from '../../portal/service/main.service';
import { ApprovalUserService } from '../../portal/service/approval-user.service';
import { ToastrService } from 'ngx-toastr';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { AllEmpService } from 'src/app/hrms/service/all-emp.service';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { Mainservice2Service } from '../service/mainservice2.service';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
declare var $: any
@Component({
  selector: 'app-after-department',
  templateUrl: './after-department.component.html',
  styleUrls: ['./after-department.component.css']
})
export class AfterDepartmentComponent {

  list_flag: boolean = true
  httpUrl: any;
  constructor(private http: HttpClient, private main: Mainservice2Service, private allEmpService: AllEmpService, private toastr: ToastrService, public ApprovalUserService: ApprovalUserService, public portalmainservice: portalmainservice, public clerkNocService: ClerkNocService, private mainserviceEmb: MainService, public spinner: NgxSpinnerService, private editorService: EditorService,) {
    this.httpUrl = this.main.httpUrl;
  }
  logObj = { component: 'After-department' }
  fourth: any;
  second: any;
  third: any;
  isLinear: any;
  first: any;
  show = false
  pet_details = null
  pet_data = []
  NocObj: any = {}
  draft_man: any = true
  displayedColumns: any = ['si_no', 'applicant_name', 'file_number', 'letter_number', 'status', 'action'];
  displayedColumns1: any = ['si_no', 'applicant_name', 'file_number', 'bill_id', 'letter_number', 'status', 'action'];
  displayedColumns_chief_eng: any = ['si_no', 'applicant_name', 'file_number', 'letter_number', 'Date', 'Property_Size', 'Bill_Amount', 'Preview', 'action'];

  datasource: any;
  datasource1: any;
  datasource_approved_bill: any;
  datasource_chief_eng: any;
  datasource_chief_eng_approved: any
  datasource_bill_reject: any
  billpay_datasource: any

  verifyed_datasource: any
  @ViewChild('paginator', { static: false }) paginator!: MatPaginator;
  @ViewChild('sortCol', { static: false }) sortCol!: MatSort;
  @ViewChild('paginator1', { static: false }) paginator1!: MatPaginator;
  @ViewChild('sortCol1', { static: false }) sortCol1!: MatSort;
  @ViewChild('paginator3', { static: false }) paginator3!: MatPaginator;
  @ViewChild('sortCol3', { static: false }) sortCol3!: MatSort;
  @ViewChild('paginator4', { static: false }) paginator4!: MatPaginator;
  @ViewChild('sortCol4', { static: false }) sortCol4!: MatSort;
  @ViewChild('paginator5', { static: false }) paginator5!: MatPaginator;
  @ViewChild('sortCol5', { static: false }) sortCol5!: MatSort;
  @ViewChild('paginator6', { static: false }) paginator6!: MatPaginator;
  @ViewChild('sortCol6', { static: false }) sortCol6!: MatSort;
  @ViewChild('paginator7', { static: false }) paginator7!: MatPaginator;
  @ViewChild('sortCol7', { static: false }) sortCol7!: MatSort;
  @ViewChild('paginator8', { static: false }) paginator8!: MatPaginator;
  @ViewChild('sortCol8', { static: false }) sortCol8!: MatSort;

  @ViewChild('paginator9', { static: false }) paginator9!: MatPaginator;
  @ViewChild('sortCol9', { static: false }) sortCol9!: MatSort;

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }
  applyFilterchfeng(filterValue: string) {
    this.datasource_chief_eng.filter = filterValue.trim().toLowerCase();
  }
  clerk_flag = false
  ctp_flag = false
  eng_Dept_flag = false
  role: any
  status: any
  ebillUser: any
  b_acct_id: any
  chief_eng: any = false
  amc_flag: any = false
  async ngOnInit() {
    this.status = null
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    // await this.getfileid()
    window.scroll(0, 0);


    await this.getAllUsersInfo()
    // await this.get_party_data();
    // await this.get_issue_data();
    // await this.getnode_cd();
    // await this.getallworkflowuser();
    console.log(this.ebillUser);
    this.role = null
    for (let i = 0; i < this.ebillUser.role_cd.length; i++) {
      if (this.ebillUser.role_cd[i] == 'DRFT_MAN') {
        // this.clerk_flag = true
        this.role = this.ebillUser.role_cd[i]
        this.ctp_flag = false
        this.eng_Dept_flag = false
        this.draft_man = true
        this.status = "ASSIGN_TO_"
        // this.status = "ASSIGN_TO_" + this.role
        this.clerkNocService.role_bill = false
        // await this.getallchefengdata()

      } else if (this.ebillUser.role_cd[i] == 'CTP') {
        this.role = this.ebillUser.role_cd[i]
        this.ctp_flag = true
        this.eng_Dept_flag = false
        this.draft_man = false
        this.chief_eng = false
        this.amc_flag = false
        this.status = "ASSIGN_TO_"

        // this.status = "ASSIGN_TO_" + this.role
        this.clerkNocService.role_bill = true
      }
      else if (this.ebillUser.role_cd[i] == "CHEIF ENG") {
        this.role = this.ebillUser.role_cd[i]
        this.clerk_flag = false
        this.chief_eng = true
        this.eng_Dept_flag = false
        this.draft_man = false
        this.ctp_flag = false
        this.status = "ASSIGN_"
        // this.status = "ASSIGN_" + this.role
        this.clerkNocService.role_bill = true
        await this.getallchefengdata()
      }
      else if (this.ebillUser.role_cd[i] == "AMC") {
        console.log("iaminamc")
        this.role = this.ebillUser.role_cd[i]
        this.clerk_flag = false
        this.ctp_flag = false
        this.eng_Dept_flag = false
        this.amc_flag = true
        this.draft_man = false
        this.status = "ASSIGN_"

        // this.status = "ASSIGN_" + this.role
        this.clerkNocService.role_bill = true
        await this.getallchefengdata()

      }
      else {
        // this.chief_eng = false
        // this.amc_flag = false
        // this.draft_man = false
        // this.ctp_flag = false
      }

    }
    console.log(this.ctp_flag, this.clerk_flag);
    await this.getalltaskuser();
    await this.getAllTaskOfUser();
    await this.get_all_bill();
    await this.getnode_cd();
  }

  allUser: any = [];
  UserObj: any = {};
  async getAllUsersInfo() {
    var obj: any = {};
    obj["b_acct_id"] = this.b_acct_id
    var resp = await this.allEmpService.getAllPartyFields(JSON.stringify(obj));
    // var resp = await this.userAdd.getAllUsersInfo(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.allUser = resp['data'];
      for (let i = 0; i < this.allUser.length; i++) {
        this.UserObj[this.allUser[i]['le_id']] = this.allUser[i]['emp_name']
        this.allUser[i]['name'] = this.allUser[i]['emp_name']
      }
      console.log(this.UserObj)
    } else {

    }
  }
  chief_eng_data: any = []
  async getallchefengdata() {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj["user_id"] = this.ebillUser.user_id
    obj["role_cd"] = this.role
    let resp = await this.clerkNocService.getchief_eng_billdata(JSON.stringify(obj))

    //  console.log(resp);
    if (resp["error"] == false) {
      this.chief_eng_data = []
      this.chief_eng_data = resp['data']
    }

    let k = 1
    for (let i = 0; i < this.chief_eng_data.length; i++) {
      this.chief_eng_data[i]['new_index'] = k
      k = k + 1
    }
    console.log(this.chief_eng_data);
    let rejecteddata: any = []
    let approved_bill: any = []
    let inProgress_bill: any = []

    this.chief_eng_data.forEach((element: any) => {
      if (element.status == 'REJECTED') {
        rejecteddata.push(element)
      } else if (element.status == 'SEND_TO_CUSTOMER') {
        approved_bill.push(element)

      }
      else {
        inProgress_bill.push(element)
      }
    });
    console.log(this.chief_eng_data, "chiefengdata");
    console.log(inProgress_bill, "inProgress_bill");

    let o = 1
    for (let i = 0; i < inProgress_bill.length; i++) {
      inProgress_bill[i]['new_index'] = o
      o = o + 1
    }
    let l = 1
    for (let i = 0; i < rejecteddata.length; i++) {
      rejecteddata[i]['new_index'] = l
      l = l + 1
    }
    let m = 1
    for (let i = 0; i < approved_bill.length; i++) {
      approved_bill[i]['new_index'] = m
      m = m + 1
    }

    // let rejecteddata = this.chief_eng_data.filter((item:any)=>item.status == 'REJECTED')
    this.datasource_chief_eng = new MatTableDataSource(inProgress_bill)
    this.datasource_chief_eng.paginator = this.paginator7;
    this.datasource_chief_eng.sort = this.sortCol7;

    this.datasource_bill_reject = new MatTableDataSource(rejecteddata)
    this.datasource_bill_reject.paginator = this.paginator8;
    this.datasource_bill_reject.sort = this.sortCol8;

    this.datasource_chief_eng_approved = new MatTableDataSource(approved_bill)
    this.datasource_chief_eng_approved.paginator = this.paginator6;
    this.datasource_chief_eng_approved.sort = this.sortCol6;

  }
  datasource_appr_file: any
  node_code: any = []
  async getnode_cd() {
    let obj: any = {}
    this.node_code = []
    obj["b_acct_id"] = this.b_acct_id;
    obj["user_id"] = this.ebillUser.user_id
    obj["status"] = 'ACTIVE'
    let resp = await this.clerkNocService.getnode_cd(JSON.stringify(obj))
    console.log(resp);
    if (resp["error"] == false) {
      this.node_code = resp['data'].map((item: { node_cd: any; }) => item.node_cd)
    }
  }

  allTaskArr: any = []
  allAprvlData: any = []
  show_ctp_flag_af_app_dep: any = false
  async getAllTaskOfUser() {
    // this.allTaskArr = []
    var obj: any = Object()
    obj['b_acct_id'] = this.ebillUser.b_acct_id
    obj['user_id'] = this.ebillUser.user_id
    obj["status"] = 'PENDING'
    obj["module_cd"] = 'NOC'
    obj["doc_type"] = ['TAX', 'PROPERTY', 'ENGINEERING']
    obj["status"] = 'LAST_LEVEL_APPROVED'
    // obj["role"] = this.role
    var resp = await this.clerkNocService.getalldataafterapprvl(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.allAprvlData = []
      // this.allTaskArr = resp['data']
      this.allAprvlData = resp['after_apprvl_data']
      console.log(this.allAprvlData,this.allTaskArr);

      if (this.allAprvlData.length > 0) {
        this.show_ctp_flag_af_app_dep = true
      }
      console.log(this.show_ctp_flag_af_app_dep, this.ctp_flag, this.list_flag);



      let k = 1
      for (let i = 0; i < this.allAprvlData.length; i++) {
        this.allAprvlData[i]['new_index'] = k
        k = k + 1
      }
    } else {
      Swal.fire("Error", resp['data'], 'error');
    }
    let approved_files = []
    // approved_files =this.allAprvlData.filter((item:any)=> item.life_cycle_status != 'ASSIGN_TO_DRFT_MAN')
    approved_files = this.allAprvlData.filter((item: any) => item.life_cycle_status != 'VERIFYED' && item.life_cycle_status != 'BILL_PAID')

    let inprocss_file = []
    inprocss_file = this.allAprvlData.filter((item: any) => item.life_cycle_status == 'LAST_LEVEL_APPROVED')
    let verifyed_bill = []
    verifyed_bill = this.allAprvlData.filter((item: any) => item.life_cycle_status == 'VERIFYED')
    let approved_bills = []
    approved_bills = this.allAprvlData.filter((item: any) => item.life_cycle_status == 'BILL_PAID')
    this.datasource_appr_file = new MatTableDataSource(approved_files)
    this.datasource_appr_file.paginator = this.paginator3;
    this.datasource_appr_file.sort = this.sortCol3;

    let inprocss_drft_man_file = []
    inprocss_drft_man_file = this.allAprvlData.filter((item: any) => item.life_cycle_status == 'ASSIGN_TO_DRFT_MAN')
    if (this.ctp_flag == true) {

      this.datasource = new MatTableDataSource(this.allAprvlData)
      this.datasource.paginator = this.paginator1;
      this.datasource.sort = this.sortCol1;
    }
    else if (this.draft_man == true) {
      console.log(inprocss_drft_man_file);
     inprocss_drft_man_file.forEach((x: any)=>{
         this.allTaskArr.forEach((y:any)=>{
          if(y.doc_local_no == x.file_id){
            x['id'] = y.id
          }
         })
     })
      this.datasource = new MatTableDataSource(inprocss_drft_man_file)
      this.datasource.paginator = this.paginator1;
      this.datasource.sort = this.sortCol1;
    }


    this.verifyed_datasource = new MatTableDataSource(verifyed_bill)
    this.verifyed_datasource.paginator = this.paginator5;
    this.verifyed_datasource.sort = this.sortCol5;

    this.billpay_datasource = new MatTableDataSource(approved_bills)
    this.billpay_datasource.paginator = this.paginator9;
    this.billpay_datasource.sort = this.sortCol9;

  }

  create_flag: boolean = false
  // /////////////////////////////////////////////////
  async get_all_bill() {
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id;
    let resp: any = await this.clerkNocService.getallbill(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      let approved_bill = []
      approved_bill = resp.data.filter((item: any) => item.bill_status == 'BILL_PAID')
      this.datasource1 = new MatTableDataSource(resp['data'])
      this.datasource1.paginator = this.paginator4;
      this.datasource1.sort = this.sortCol4;
      this.datasource_approved_bill = new MatTableDataSource(approved_bill)
      this.datasource_approved_bill.paginator = this.paginator;
      this.datasource_approved_bill.sort = this.sortCol;
    } else {
      Swal.fire('error', 'server side error', 'error');
      return
    }

  }

  Obj: any = {}
  async generate(element: any) {
    console.log(element)
    this.salBill_apprdata = null
    this.salBill_apprdata = Object.assign({}, element)
    let obj: any = {};
    obj['b_acct_id'] = this.b_acct_id;
    obj['file_id'] = element.file_id
    let resp = await this.clerkNocService.get_all_notesheet(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      resp['data'].map((x: any) => {
        this.notesheet_desc.push({
          'desc': JSON.parse(x.description),
          'notesheet_id': x.notesheet_id,
          'role': x.create_role,
          'user_id': x.user_id,
          'file_id': x.file_id
        });
      })
      this.list_flag = false;
      this.create_flag = true;
      // this.chief_eng=false
      this.Obj = element
      await this.suppor_doc(element)
      console.log(this.notesheet_desc)
      return
    } else {
      Swal.fire('error', 'server side error', 'error');
      return
    }

    // this.clerkNocService.data_for_bill = element;
  }


  page_flag: boolean = true;
  bill_flag: boolean = false

  Draftman() {
    window.scroll(0, 0);
    this.page_flag = false;
    this.bill_flag = true;

    this.clerkNocService.Obj = this.Obj;
  }
  back() {
    window.scroll(0, 0);
    // this.ctp_flag=false
    this.list_flag = true;
    this.create_flag = false;
    this.Obj = null;
    if(this.role=='DRFT_MAN'){
      this.draft_man=true
      this.chief_eng=false
      this.ctp_flag = false
      this.amc_flag=false
    }else if(this.role=='CTP'){

      this.ctp_flag = true
      this.draft_man=false
      this.chief_eng=false
      this.amc_flag=false
    }
    else if(this.role=="CHEIF ENG"){
      this.chief_eng=true
      this.ctp_flag = false
      this.draft_man=false
      this.amc_flag=false
    }
    else if(this.role=="AMC"){
      this.chief_eng=false
      this.ctp_flag = false
      this.draft_man=false
      this.amc_flag=true
    }
 
  }

  back_dft() {
    window.scroll(0, 0);
    this.page_flag = true;
    this.bill_flag = false;
    this.clerkNocService.Obj = null;
  }
  notesheet_desc: any = []



  ////////////////////////////////////////////////////////
  supp_doc: any = []
  async suppor_doc(element: any) {
    let obj: any = {};
    obj['b_acct_id'] = this.b_acct_id;
    obj['file_id'] = element.file_id
    let resp = await this.clerkNocService.supporting_doc(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      this.supp_doc = resp['data']
      // for(let i = 0 ; i < this.notesheet_desc.length ; i++){
      //   this.notesheet_desc[i]['supp_doc'] = []
      //   for(let j = 0 ; j < this.supp_doc.length ; j++){
      //     if(this.notesheet_desc[i]['notesheet_id'] === this.supp_doc[j]['notesheet_id']){
      //           this.notesheet_desc[i]['supp_doc'].push(this.supp_doc[j]);
      //     }
      //   }
      // }
      console.log(this.supp_doc)
    } else {
      Swal.fire('error', 'server side error', 'error');
      return
    }
  }
  // ///////////////////////////////////////////
  fileURL: any
  async view_correspondence(correspondence_no: any) {
    console.log(correspondence_no)
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['doc_name'] = correspondence_no
    obj['file_id'] = this.clerkNocService.file_id
    var res = await this.clerkNocService.viewCorrespondence(obj)

    if (res) {
      let file = new Blob([res], { type: 'application/pdf' });
      this.fileURL = URL.createObjectURL(file);
      // console.log(fileURL)
      window.open(this.fileURL)
      // PDFObject.embed(this.fileURL, '#pdf')
    } else {

    }


  }
  // ///////////////
  async submit() {

    if (!this.clerkNocService.Obj['floor_buld_area']) {
      Swal.fire('info', 'Please enter the All Floors Building area.', 'info');
      return
    }
    if (!this.clerkNocService.Obj['total_area']) {
      Swal.fire('info', 'Please Enter Total Area', 'info');
      return
    }
    if (!this.clerkNocService.Obj['front_stack']) {
      Swal.fire('info', 'Please enter the front setback.', 'info');
      return
    }
    if (!this.clerkNocService.Obj['side_stack_l']) {
      Swal.fire('info', 'Please enter the Side Setback L.', 'info');
      return
    }
    if (!this.clerkNocService.Obj['side_stack_r']) {
      Swal.fire('info', 'Please enter the Side Setback R.', 'info');
      return
    } if (!this.clerkNocService.Obj['rare_stack']) {
      Swal.fire('info', 'Please enter the Rare Set Back.', 'info');
      return
    }
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Submit it!'
    }).then(async (result) => {
      if (result.value) {
        console.log(this.clerkNocService.Obj)
        this.clerkNocService.Obj['b_acct_id'] = this.b_acct_id
        let resp = await this.clerkNocService.generate_bill(this.clerkNocService.Obj);
        console.log(resp);
        if (resp['error'] == false) {
          // Swal.fire('success', resp['data'], 'success');
          this.clerkNocService.Obj = null;
          await this.Approvedapproval()
          await this.back_dft();
          
          // await this.back();
          await this.get_all_bill();
          
          if(this.role=='DRFT_MAN'){
            this.draft_man=true
          }
         

          //  this.router.navigate(['NOC/after-department'])
          return
        } else {
          if (resp['data1']) {
            Swal.fire('info', resp['data1'], 'info');
            return
          } else {
            Swal.fire('error', 'server side error', 'error');
            return
          }
        }
      }
    })


  }

  // ////////////////////////////////////////////////print bill /////////////////////////////////////////////////////////
  async print(element: any,type:any) {
    let log = await this.clerkNocService.getlogophoto();
    let c = await this.blobToBase64(log)


    const txt = "NOC Bill";
    const txtfooter = '';

    const objHeading1 = {
      text: txt, alignment: 'center', fontSize: 18, bold: true, style: 'header',
    };

    const dd: any = {
      pageSize: 'A4',
      footer: function (currentPage: any, pageCount: any) {
        return {
          columns: [
            { text: txtfooter + currentPage.toString() + ' of ' + pageCount, alignment: 'center', bold: true, style: 'header' }
          ]
        };
      },
      pageOrientation: 'portrait',
      pageMargins: [15, 30, 15, 30],
      content: [
        objHeading1,
        // Other content elements go here
      ],
      background: function (currentPage: any, pageSize: any) {
        return {
          image: c,
          width: 350,
          height: 350,
          opacity: 0.3,
          margin: [120, 200, 50, 10]
        };
      }
    };
    let txt2 = "Junior Engineer/ Chief architect/ Chef Engineer/Additional Municipal Commissioner"
    let txt3 = "Additional Municipal Commissioner"
    let txt4 = 'Please Visit' + " " + element.building_type + " " + element.party_name + " Plot No." + " " + element.plot_no + " Khasra No." + " " + element.khasra_no
    let txt5 = element.address
    let txt6 = "Applicable Fees"
    let txt7 = "Please order the applicant to deposit the above mentioned amount of " + "₹ " + element.bill_amount + " in the Municipal Corporation fund so that advance action can be takedn on the no objection letter to be sent to the Lucknow Authority.Therefor, the report/calculations are sent for approval along with recommendations."

    var header1 = {
      text: txt2, alignment: 'center', fontSize: 13, bold: true, style: 'header'
    }
    var header2 = {
      text: txt3, alignment: 'center', fontSize: 13, bold: true, style: 'header'
    }
    var header3 = {
      text: txt4, alignment: 'center', fontSize: 10, style: 'header',
    }
    var header4 = {
      text: txt5, alignment: 'center', fontSize: 10, style: 'header',
    }
    var header6 = {
      text: txt6, alignment: 'left', fontSize: 11, bold: true, style: 'header',
    }
    var header9 = {
      text: txt7, alignment: 'left', fontSize: 10, style: 'header',
    }
    dd.content.push({ text: " " });
    dd.content.push(header1);
    dd.content.push(header2);
    dd.content.push({ text: " " });
    dd.content.push(header3);
    dd.content.push(header4);

    var header5 = {
      columns: [
        {
          width: 60,
          text: "Letter No. : ",
          bold: true,
          fontSize: 10,
          alignment: 'left'
        },
        {
          width: 100,
          text: element.lda_letter_number,
          bold: true,
          fontSize: 10,
          alignment: 'left',

        },
        {
          width: 325,
          text: '',
          bold: true,
          fontSize: 10,
          alignment: 'right',

        },
        {
          width: 30,
          text: "Date :",
          bold: true,
          fontSize: 10,
          alignment: 'right'
        },
        {
          width: 60,
          text: element.date,
          bold: true,
          fontSize: 10,
          alignment: 'right',

        }

      ],


    }
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    dd.content.push(header5);
    dd.content.push({ text: " " });

    var tbl = {
      fontSize: 12,
      table: {
        headerRows: 1,
        widths: [30, 400, 110],
        body: [
          [
            { text: 'S.No.', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, },
            { text: 'Parameters (Static Field)', fontSize: 10, alignment: 'center', style: 'tableHeader', bold: true, },
            { text: 'Input', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, },
          ],
          [
            { text: '01', alignment: 'center', fontSize: 10 },
            { text: 'Area of building land as per submitted Building map area', fontSize: 10, alignment: 'left' },
            { text: element.total_area, alignment: 'center', fontSize: 10 },
          ],
          [
            { text: '02', alignment: 'center', fontSize: 10 },
            { text: 'Land use of the Presented Building Map', fontSize: 10, alignment: 'left' },
            { text: element.building_type, alignment: 'center', fontSize: 10 },
          ],
          [
            { text: '03', alignment: 'center', fontSize: 10 },
            { text: 'All Floor Covered as per submitted Building map Area', fontSize: 10, alignment: 'left' },
            { text: element.floor_buld_area, alignment: 'center', fontSize: 10 },
          ],
          [
            { text: '04', alignment: 'center', fontSize: 10 },
            { text: 'As Per the Presented Building map', fontSize: 10, alignment: 'left' },
            { text: '', alignment: 'center', fontSize: 10 },
          ],
          [
            { text: '', alignment: 'center', fontSize: 10 },
            { text: '(I) Front SetBack ', fontSize: 10, alignment: 'right' },
            { text: element.front_stack, alignment: 'center', fontSize: 10 },
          ],
          [
            { text: '', alignment: 'center', fontSize: 10 },
            { text: '(II) Side Setback-L ', fontSize: 10, alignment: 'right' },
            { text: element.side_stack_l, alignment: 'center', fontSize: 10 },
          ],
          [
            { text: '', alignment: 'center', fontSize: 10 },
            { text: '(III) Side Setback-R ', fontSize: 10, alignment: 'right' },
            { text: element.side_stack_r, alignment: 'center', fontSize: 10 },
          ],
          [
            { text: '', alignment: 'center', fontSize: 10 },
            { text: '(IV) Rear Setback ', fontSize: 10, alignment: 'right' },
            { text: element.rare_stack, alignment: 'center', fontSize: 10 },
          ],
        ]
      },
      layout: {
        hLineWidth: function (i: number, node: { table: { body: string | any[]; }; }) {
          return (i === 0 || i === node.table.body.length) ? 1 : (i === 1 ? 1 : 0);
        },
        vLineWidth: function (i: number, node: { table: { widths: string | any[]; }; }) {
          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
        },
        hLineColor: function (i: any, node: any) {
          return 'black';
        },
        vLineColor: function (i: any, node: any) {
          return 'black';
        }
      }
    };


    dd.content.push(tbl)
    dd.content.push({ text: " " });
    dd.content.push(header6);
    var tbl2: any = {

      fontSize: 12,
      table: {

        headerRows: 1,
        widths: [30, 200, 100, 90, 100],

        body: [

          [
            { text: 'S.No.', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, },
            { text: 'Municipal Corporation Fee Details', fontSize: 10, alignment: 'center', style: 'tableHeader', bold: true, },
            { text: 'Rate Per Square meter', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, },
            { text: 'Area Sq/mtr', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, },
            { text: 'Amount', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, },


          ],

          [
            { text: '01', alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: 'Reinforcement fee', fontSize: 10, alignment: 'center', style: 'tableHeader' },
            { text: "₹ " + element.reinfor_fees, alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: element.total_area, alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: "₹ " + element.total_reinfor_fees, alignment: 'center', fontSize: 10, style: 'tableHeader' },
          ],
          [
            { text: '02', alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: 'Dump Fee', fontSize: 10, alignment: 'center', style: 'tableHeader' },
            { text: "₹ " + element.reinfor_fees, alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: element.total_area, alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: "₹ " + element.total_dump_fees, alignment: 'center', fontSize: 10, style: 'tableHeader' },
          ], [
            { text: '03', alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: 'Inspection fee', fontSize: 10, alignment: 'center', style: 'tableHeader' },
            { text: "₹ " + element.dump_fees, alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: element.inspection_fees, alignment: 'center', fontSize: 10, style: 'tableHeader' },
            { text: "₹ " + element.total_inspection_fees, alignment: 'center', fontSize: 10, style: 'tableHeader' },
          ],
        ]
      }
    };
    console.log(element.bill_amount);
    if (!this.clerkNocService.Obj) {
      this.clerkNocService.Obj = {}; // Initialize Obj if it's null
    }
    this.clerkNocService.Obj['bill_amount'] = element['bill_amount']
    await this.clerkNocService.convertToWords()
    dd.content.push({ text: " " });
    dd.content.push(tbl2)
    var header7 = {
      columns: [
        {
          width: 30,
          text: '',
          bold: false,
          fontSize: 10,
          // alignment: 'left'
        },
        {
          width: 100,
          text: "Total Receive amount",
          bold: true,
          fontSize: 10,
          alignment: 'left',
        },
        {
          width: 325,
          text: '',
          bold: false,
          fontSize: 10,
          alignment: 'right',
          color: 'gray'
        },
        {
          width: 100,
          text: "₹ " + element.bill_amount,
          bold: true,
          fontSize: 10,
          alignment: 'right'
        },
        {
          width: 30,
          text: '',
          bold: false,
          fontSize: 10,
          alignment: 'right',
          color: 'gray'
        }

      ],


    }
    var header8 = {
      columns: [
        {
          width: 30,
          text: '',
          bold: false,
          fontSize: 10,
          alignment: 'left'
        },
        {
          width: 50,
          text: "In Words",
          bold: true,
          fontSize: 10,
          alignment: 'left',

        },
        {
          width: 100,
          text: '',
          bold: false,
          fontSize: 10,
          alignment: 'right',
          color: 'gray'
        },
        {
          width: 380,
          text: this.clerkNocService.Obj['bill_word'],
          bold: true,
          fontSize: 10,
          alignment: 'right'
        },
        {
          width: 30,
          text: '',
          bold: false,
          fontSize: 10,
          alignment: 'right',
          color: 'gray'
        }

      ],


    }
    dd.content.push({ text: " " });
    dd.content.push(header7);
    dd.content.push({ text: " " });
    dd.content.push(header8);
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    dd.content.push(header9);


   if(type=='view'){
    // pdfMake.createPdf(dd).download('NOC_BILL.pdf');
    pdfMake.createPdf(dd).open();

   }else{
    pdfMake.createPdf(dd).download('NOC_BILL.pdf');

   }

  }

  blobToBase64(blob: any) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }


  salBill_apprdata: any
  async send_to_draft_man(element: any) {
    this.salBill_apprdata = null
    this.salBill_apprdata = Object.assign({}, element)
    let obj: any = {};
    obj['b_acct_id'] = this.b_acct_id;
    obj['file_id'] = element.file_id
    let resp = await this.clerkNocService.get_all_notesheet(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      resp['data'].map((x: any) => {
        this.notesheet_desc.push({
          'desc': JSON.parse(x.description),
          'notesheet_id': x.notesheet_id,
          'role': x.create_role,
          'user_id': x.user_id,
          'file_id': x.file_id
        });
      })
      this.list_flag = false;
      this.create_flag = true;
      this.Obj = element
      await this.suppor_doc(element)
      console.log(this.notesheet_desc)
      return
    } else {
      Swal.fire('error', 'server side error', 'error');
      return
    }
  }

  appr_remark: any
  forwarded_user_id: any
  undertakings: any = []
  message_flag: any = false
  async send_for_billing() {





    this.appr_remark = null
    this.forwarded_user_id = null
    this.salBill_apprdata['level'] = 1
    this.salBill_apprdata['branch'] = 1
    this.salBill_apprdata['doc_local_no'] = this.salBill_apprdata['file_id']

    this.salBill_apprdata['doc_type'] = 'BILL'

    this.salBill_apprdata['node_cd'] = this.salBill_apprdata['node_cd'] !== undefined ? this.salBill_apprdata['node_cd'] : this.node_code[0];

    this.salBill_apprdata['module_cd'] = 'NOC';
    // this.salBill_apprdata['node_cd'] = this.node_code

    await this.ApprovalUserService.getWorkflowlog(this.ebillUser, this.salBill_apprdata['doc_type'], 'NOC');
    console.log(this.ApprovalUserService.workflow_level1);

    if (this.ApprovalUserService.workflow_level1 == undefined) {
      // await this.ChangestatusSalBill(this.salBill_apprdata['doc_local_no'], 'APPROVED')
      return;
    }
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.ebillUser, this.salBill_apprdata)
    await this.ApprovalUserService.getWorkflowloguser(this.ebillUser, this.salBill_apprdata)
    /* await this.getAllRule();
    await this.getundertakings(element); */
    $('#myModal3').modal('show');
  }

  isResponseReceived: boolean = false;
  // level1 = {};
  async Approvedapproval() {
    this.spinner.show()

    let obj: any = {}
    obj['doc_type'] = 'BILL'
    obj['doc_local_no'] = this.salBill_apprdata['file_id']
    obj['module_cd'] = 'NOC'
    obj["b_acct_id"] = this.b_acct_id
    let status = this.status + this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd'];
    let resp1 = await this.clerkNocService.getworkflowloguser(JSON.stringify(obj))
    if (resp1["error"] == false) {
      if (resp1.data.length == 0) {

        this.isResponseReceived = true
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          let obb: any = new Object();

          obb['user_id'] = this.ebillUser.user_id
          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.appr_remark
          obb['remark'] = this.appr_remark
          obb['status'] = 'APPROVED'
          obb['doc_type'] = 'BILL'

          // if (this.clerk_flag == true) {

          //   obb['doc_type'] = 'CTP'

          //   status = 'ASSINGED_CTP'
          // } else if (this.eng_Dept_flag == true) {
          //   // obb['doc_type'] = 'ENGINEERING'

          //   status = this.status
          //   this.salBill_apprdata = this.alltabledata

          // }
          obb['doc_local_no'] = this.salBill_apprdata['file_id']
          // obb['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
          obb['role_cd'] = this.role//this.level1['role_cd']
          
          obb['module_cd'] = 'NOC'
          obb['node_cd'] = this.node_code
          obb['level'] = this.ApprovalUserService.level1['level']
          obb['undertaking'] = JSON.stringify([])
          obb['branch'] = this.ApprovalUserService.level1['branch']
          obb['user_name'] = this.ebillUser.party_name;
          obb['field_value'] = 0
          obb['doc_desc'] = `This Filid NO ${this.salBill_apprdata['file_id']} Is Assigned to ${this.role}`



          let resp = await this.mainserviceEmb.insertTask(obb)
          if (resp['error'] == false) {
            await this.pendingapproval()



            await this.ChangeStatus(this.salBill_apprdata['file_id'], status, obb)

            // else if (this.eng_Dept_flag == true) {

            //   await this.changedeptstatus(this.salBill_apprdata['file_id'], status, obb)

            // }
            // await this.getallfiledata()

            this.spinner.hide();
            if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
              // obb['user_id'] = -1
              // obb['vendor_id'] = this.selectedTender['party_id']
              if (this.message_flag == true) {
                /* await this.getle(this.selectedTender['party_id']) */
              }

            } else {
              // if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'])

            }
            this.toastr.success("Approval Forwarded Successfully!!")
            console.log("Approval Forwarded Successfully!!")
          } else {
            this.spinner.hide();
            console.log(resp['data'])
            this.isResponseReceived = false;
            // this.toastr.errorToastr(resp['data'])
          }
        } else {
          this.isResponseReceived = false;
          // this.toastr.errorToastr("Please Select Any User..!")
          this.spinner.hide();
        }
      }
      else {
        this.spinner.show()
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          var obb: any = new Object();
          if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
            obb['user_id'] = -1
            if (this.allTaskArr['party_id'] == null || this.allTaskArr['party_id'] == undefined) {
              Swal.fire("Error", "Please Map Verdor with Work..!", 'error');
              return
            }
            obb['vendor_id'] = this.allTaskArr['party_id']
          } else {
            obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
          }
          if (obb["user_id"] == -1) {
            let userData: any = {};
            userData['b_acct_id'] = this.b_acct_id;
            userData['user_id'] = obb["vendor_id"];
            let venderInfo = await this.mainserviceEmb.getVenderName(JSON.stringify(obb));
            if (venderInfo["error"] == false) {
              obb['user_name'] = venderInfo["data"]['party_leagal_name']
            }
          } else {
            for (let i = 0; i < this.ApprovalUserService.workuser.length; i++) {
              if (this.ApprovalUserService.workuser[i]['user_id'] == obb["user_id"]) {
                let h = this.ApprovalUserService.workuser[i]['desc'].split("-");
                obb['user_name'] = h[1];
              }
            }
          }


          obb['doc_local_no'] = this.salBill_apprdata['doc_local_no']
          obb['doc_desc'] = `This File NO ${this.salBill_apprdata['doc_local_no']} Is Assigned to ${this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']}`
          obb['node_cd'] = this.salBill_apprdata['node_cd']

          // if (this.selectedLang == 'Hindi') {
          //   obb['language'] = 'Hindi'
          // } else {
          //   obb['language'] = 'English'
          // }

          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.remark_note
          obb['remark'] = ""
          obb['status'] = 'PENDING'
          obb['doc_type'] = this.salBill_apprdata['doc_type']//'EBILL'
          // obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
          // obb['doc_desc'] = this.tender_apprdata['doc_desc']
          obb['undertaking'] = this.allTaskArr['undertaking']
          obb['module_cd'] = this.salBill_apprdata['module_cd'] //'EMB'
          // obb['node_cd'] = this.tender_apprdata['node_cd']
          if (this.ApprovalUserService.vendorflag == true) {
            obb['level'] = this.allTaskArr['level']
            obb['branch'] = this.allTaskArr['branch']
          }
          else {
            obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
            obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
            obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
          }

          obb['field_value'] = this.allTaskArr['field_value']

          var resp = await this.mainserviceEmb.insertTask(obb)
          if (resp['error'] == false) {
            await this.aftersentpendingapproval()
            await this.underapprovalapproval(this.allTaskArr)
            await this.ChangeStatus(this.salBill_apprdata['file_id'], status, obb)
            if (this.ApprovalUserService.conditionflag == true) await this.approvedocmentwithcondition()
            await this.getAllTaskOfUser()
            // if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
            //   if (this.message_flag == true) await this.getle(this.selectedTender['party_id'], this.ApprovalUserService.userObj[this.erpUser.le_id])
            // } else {
            //   if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.erpUser.le_id])

            // }
            if(this.role=='DRFT_MAN'){
              this.draft_man=true
            }
           
            this.spinner.hide();
            if (this.ApprovalUserService.conditionflag == false) {
              // m_avinash


              // $('#myModal2').modal('hide');


              Swal.fire("Success", "Approval Forwarded Successfully!!", 'success');

            }
            
          
          } else {
            this.spinner.hide();
            Swal.fire("Error", resp['data'], 'error');

          }
        } else {
          Swal.fire("Error", "Please Select Any User..!", 'error');

          this.spinner.hide();
        }
      }
    }



  }

  async underapprovalapproval(element: any) {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['status'] = 'UNDERAPPROVAL'
    obb['module_cd'] = this.salBill_apprdata['module_cd']
    obb['doc_type'] = this.salBill_apprdata['doc_type']
    obb['doc_local_no'] = this.salBill_apprdata['doc_local_no']
    var resp = await this.portalmainservice.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');

    }

  }

  async aftersentpendingapproval() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['remark'] = this.remark_note //this.appr_remark
    obb['status'] = 'APPROVED'
    obb['language'] = this.editorService.language
    obb['id'] = this.salBill_apprdata['id']
    obb['doc_type'] = this.salBill_apprdata['doc_type']
    obb['undertaking'] = this.allTaskArr['undertaking'] ? this.allTaskArr['undertaking'] : JSON.stringify([])


    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }


    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }
  }
  remark_note: any = null
  async ChangeStatus(id: any, status: any, obb: any) {
    let data = new FormData()
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = status;
    obj['file_id'] = id
    obj["user_id"] = this.ebillUser.user_id
    obj["department"] = obb["doc_type"]
    obj["node_cd"] = obb["node_cd"]
    obj['role_cd'] = obj['role_cd']
    if (this.ApprovalUserService.rolebyid.length > 0) {

      obj['role_user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
    }
    if (this.role) {

      obj["forwared_by"] = this.role
    }
    obj["description"] = "file send to Draftman"
    if (this.NocObj['supportive_doc']) {

      obj["supportive_doc"] = this.NocObj['supportive_doc']
    }
    obj['description'] = this.remark_note
    obj["lang"] = this.editorService.language
    obj["role_cd"] = this.role
    // obj["supportive_doc"] = this.NocObj['supportive_doc']
    data.append('data', JSON.stringify(obj))
    console.log(obj);

    this.spinner.show();
    let resp = await this.clerkNocService.changefilestatus(obj)
    // let resp = await this.clerknocservice.changedeptstatus(data)

    if (resp['error'] == false) {
      this.spinner.hide();
      console.log('Successfully Chaged to ' + status)
      this.clerk_flag = false
      // this.chief_eng = true
      this.eng_Dept_flag = false
    

      await this.getAllTaskOfUser()
      await this.back_dft();
      await this.back();
      await this.get_all_bill();
      await this.getallchefengdata()
    }
    else {
      this.spinner.hide();
      this.toastr.error(resp['data']);
    }
  }


  // async changedeptstatus(id: any, status: any, obb: any) {
  //   let data = new FormData()
  //   let obj = Object()
  //   obj['b_acct_id'] = this.b_acct_id;
  //   obj['status'] = status;
  //   obj['file_id'] = id
  //   obj["user_id"] = this.ebillUser.user_id
  //   obj["department"] = obb["doc_type"]
  //   obj["node_cd"] = obb["node_cd"]
  //   // obj['role_cd'] = obb['role_cd']
  //   if (this.ApprovalUserService.rolebyid.length > 0) {

  //     if (this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']) {

  //       obj['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
  //     }
  //     if (this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']) {

  //       obj['role_user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
  //     }
  //   }
  //   obj["forwared_by"] = this.role
  //   obj["description"] = "file send to Draftman"
  //   obj["supportive_doc"] = this.NocObj['supportive_doc']
  //   obj['description'] = this.remark_note
  //   obj["lang"] = this.editorService.language
  //   obj["supportive_doc"] = this.NocObj['supportive_doc']
  //   obj["life_cycle_status"] = this.status

  //   data.append('data', JSON.stringify(obj))
  //   console.log(obj);

  //   this.spinner.show();
  //   // let resp = await this.clerknocservice.changefilestatus(obj)
  //   let resp = await this.clerkNocService.changedeptstatus(data)

  //   if (resp['error'] == false) {
  //     this.spinner.hide();
  //     console.log('Successfully Chaged to ' + status)
  //     this.list_flag = true;

  //   }
  //   else {
  //     this.spinner.hide();
  //     this.toastr.error(resp['data']);
  //   }
  // }

  async getalltaskuser() {
    this.allTaskArr = []
    var obj = Object()
    obj['b_acct_id'] = this.ebillUser.b_acct_id
    obj['user_id'] = this.ebillUser.user_id
    obj["status"] = ['PENDING']
    obj["role_cd"] = this.role
    obj["module_cd"] = 'NOC'
    var resp = await this.portalmainservice.getAllTaskOfUser(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.allTaskArr = resp['data']
      console.log(this.allTaskArr, "all task data");

      this.portalmainservice.count = this.allTaskArr.length
    } else {
      Swal.fire("Error", resp['data'], 'error');
    }
  }

  async pendingapproval() {
    this.spinner.show()
    if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
      let obb: any = new Object();
      if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
      } else {
        obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
        obb['user_name'] = this.ApprovalUserService.userObj[this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']]
      }

      console.log(this.forwarded_user_id)
      obb['b_acct_id'] = this.ebillUser.b_acct_id
      obb['forwarded_by'] = this.ebillUser.user_id
      obb['forward_msg'] = this.appr_remark
      obb['remark'] = this.appr_remark


      obb['status'] = 'PENDING'


      obb['doc_type'] = 'BILL'
      // status = 'ASSINGED_CTP'

      obb['doc_local_no'] = this.salBill_apprdata['file_id']
      obb['doc_desc'] = `This Filid NO ${this.salBill_apprdata['file_id']} Is Assigned to ${this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']}`
      obb['module_cd'] = 'NOC'
      obb['node_cd'] = this.salBill_apprdata['node_cd']
      obb['undertaking'] = JSON.stringify([])
      if (this.ApprovalUserService.vendorflag == true) {
        obb['level'] = this.salBill_apprdata['level']
        obb['branch'] = this.salBill_apprdata['branch']
      }
      else {
        obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
        obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
        obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
      }
      obb['field_value'] = 0
      // var resp = await this.portalmainservice.updatetask(obb)
      let resp = await this.mainserviceEmb.insertTask(obb)
      if (resp['error'] == false) {

        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    } else {
      this.spinner.hide();
    }
  }

  async approvedocmentwithcondition() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['module_cd'] = this.allTaskArr['module_cd']
    obb['status'] = 'APPROVED'
    obb['doc_type'] = this.allTaskArr['doc_type']
    obb['doc_local_no'] = this.allTaskArr['doc_local_no']

    var resp = await this.portalmainservice.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
      Swal.fire("Success", "Approved Successfully!!", 'success');
    } else {
      this.spinner.hide();

      Swal.fire("Error", resp['data'], 'error');

    }

  }
  async lastlevelappr() {
    // await this.getallworklowidbyuser(this.alltabledata)
    this.spinner.show()
    var obb: any = new Object();
    let status;

    obb['doc_type'] = this.allTaskArr['doc_type']

    status = 'SEND_TO_CUSTOMER'
    // this.salBill_apprdata = this.allTaskArr


    obb['b_acct_id'] = this.ebillUser.b_acct_id
    // obb['remark'] = this.remark_note //this.appr_remark
    obb['remark'] = this.appr_remark

    obb['status'] = 'APPROVED'
    obb['language'] = this.editorService.language
    obb['id'] = this.salBill_apprdata['id']
    obb['doc_local_no'] = this.allTaskArr['file_id']
    obb['undertaking'] = JSON.stringify([])

    // if (this.editorService.language == 'Hindi') {
    //   obb['language'] = 'Hindi'
    // } else {
    //   obb['language'] = 'English'
    // }


    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      // if (this.eng_Dept_flag == true) {
    obb['status'] = 'SEND_TO_CUSTOMER'

      await this.ChangeStatus(this.salBill_apprdata['doc_local_no'], status, obb)

      // await this.changelastdeptstatus(this.salBill_apprdata['file_id'], status, obb)

      // }
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }
  }

  async billdataforchiefeng() {
    this.create_flag = false
    //  this.chief_eng=false
    this.bill_flag = true
    //  this.clerkNocService.Obj = this.Obj;
    this.clerkNocService.Obj = this.chief_eng_data.filter((item: any) => item.file_id == this.salBill_apprdata.file_id)[0]
    console.log(this.clerkNocService.Obj);

  }


  rejectDTObj: any = {}
  current_task_data: any = {}
  rejectdata: any = {}
  backrowdata: any = {}
  async reject(element: any) {
    // console.log(element);
    $('#rejected').modal('show');

    await this.editorService.clearTetx()
    // this.clearSeletedData2();
    // let element = this.current_task_data
    this.current_task_data = {}
    this.current_task_data = element
    this.rejectdata = Object.assign({}, element)
    var obj = Object.assign({}, {})

    await this.ApprovalUserService.getWorkflowlogbydocno(this.ebillUser, element)
    this.ApprovalUserService.workflowlogall = this.ApprovalUserService.workflowlogall.reverse()
    if (this.current_task_data['module_cd'] === "ACCOUNT" && this.current_task_data['level'] === 1) {

    } else {
      if (this.ApprovalUserService.workflowlogall[1]['status'] != 'REJECTED' && this.ApprovalUserService.workflowlogall[1]['status'] != 'ACCOUNT_REJECTED') {
        if (this.ApprovalUserService.workflowlogall[1]['status'] == 'REVOKED' || this.ApprovalUserService.workflowlogall[1]['user_id'] == -1) {
          for (let i = 0; i < this.ApprovalUserService.workflowlogall.length; i++) {
            if (this.ApprovalUserService.workflowlogall[i]['user_id'] == -1) continue;
            if (this.ApprovalUserService.workflowlogall[i]['level'] <= element['level'] && this.ApprovalUserService.workflowlogall[i]['branch'] <= element['branch'] && (this.ApprovalUserService.workflowlogall[i]['status'] == 'APPROVED')) {

              obj = this.ApprovalUserService.workflowlogall[i]
              break;


            }


          }
        } else {
          obj = this.ApprovalUserService.workflowlogall[1]
        }

      } else {
        for (let i = 0; i < this.ApprovalUserService.workflowlogall.length; i++) {
          if (this.ApprovalUserService.workflowlogall[i]['user_id'] == -1) continue;
          if (this.ApprovalUserService.workflowlogall[i]['level'] <= element['level'] && this.ApprovalUserService.workflowlogall[i]['branch'] <= element['branch'] && (this.ApprovalUserService.workflowlogall[i]['status'] == 'APPROVED')) {
            if (this.ApprovalUserService.workflowlogall[i]['user_id'] == element['user_id'] && this.ApprovalUserService.workflowlogall[i]['role_cd'] == element['role_cd']) {

              if (this.ApprovalUserService.workflowlogall[i + 1] == undefined && this.rejectdata['doc_type'] == "DEFENDANT DOCS" && this.rejectdata['module_cd'] == 'ICMS') {
                // await this.finalreject()
                return;
              }
              if (this.ApprovalUserService.workflowlogall[i + 1] == undefined) {
                break;

              }
              else {
                if (this.ApprovalUserService.workflowlogall[i + 1]['user_id'] == -1) {
                  obj = this.ApprovalUserService.workflowlogall[i + 2]
                  break;
                } else {
                  obj = this.ApprovalUserService.workflowlogall[i + 1]
                  break;
                }
              }


            }

          }


        }
      }
    }
    this.backrowdata = Object.assign({}, obj)
    this.rejectDTObj = Object.assign({}, element)
    // await this.finalreject()


  }
  async finalreject() {

    this.remark_note = this.editorService.to_data
    // let str = this.remark_note.trim()
    // if (str.length < 1) {
    if (this.remark_note == null) {
      Swal.fire('Info', "Please fill Mandatory Details", 'info');
      return
    }
    this.spinner.show()
    let obb = Object()
    obb['user_id'] = this.backrowdata['forwarded_by']


    obb["user_name"] = this.backrowdata['user_name'];
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['forwarded_by'] = this.ebillUser.user_id
    obb['forward_msg'] = this.remark_note
    obb['remark'] = ""
    obb['status'] = 'PENDING'
    obb['doc_type'] = this.backrowdata['doc_type']//'EBILL'
    obb['doc_local_no'] = this.backrowdata['doc_local_no']
    obb['doc_desc'] = this.backrowdata['doc_desc']
    obb['role_cd'] = this.backrowdata['role_cd']
    obb['module_cd'] = this.backrowdata['module_cd'] //'EMB'
    obb['node_cd'] = this.backrowdata['node_cd']
    obb['level'] = this.backrowdata['level']
    obb['branch'] = this.backrowdata['branch']
    obb['field_value'] = this.backrowdata['field_value']
    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }

    const resp = await this.portalmainservice.insertTask(obb)
    if (resp['error'] == false) {
      await this.rejectapproval(this.rejectDTObj['id'])
      await this.rejectfilestatus(this.rejectDTObj['doc_local_no'], 'REJECTED')
      // if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.ebillUser.le_id])
      this.spinner.hide();
      // $('#multiple_view').hide()

      this.ApprovalUserService.workflowlogall = this.ApprovalUserService.workflowlogall.reverse()
      Swal.fire("Success", "Objected Successfully!!", 'success');
      await this.getAllTaskOfUser()
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');

    }
  }
  async rejectfilestatus(data: any, status: any) {

    let obj: any = {}
    obj["file_id"] = data
    obj["status"] = status
    obj["b_acct_id"] = this.b_acct_id
    obj["user_id"] = this.ebillUser.user_id
    let resp = await this.clerkNocService.rejectfile(obj)
    console.log(resp)



  }
  async rejectapproval(element: any) {
    this.spinner.show()
    let obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['remark'] = this.remark_note
    obb['status'] = 'REJECTED'
    obb['id'] = element

    if (this.editorService.language == 'Hindi') {

      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }
    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }

  }

  nocObj: any = {}
  dept_data: any = []
  // async nocgeneration(element: any) {
  //   console.log(element);
  //   let obj: any = Object.assign({}, element)
  //   obj["b_acct_id"] = this.b_acct_id
  //   obj["status"] = 'LAST_LEVEL_APPROVED'
  //   obj["doc_type"] = ['ENGINEERING', 'PROPERTY', 'TAX']

  //   try {
  //     let resp:any = await this.clerkNocService.getprintdata(JSON.stringify(obj));
  //     console.log(resp);

  //     if (resp) {
  //       // Create a URL for the Blob and trigger the download
  //       // const url = window.URL.createObjectURL(resp);
  //       // const a = document.createElement('a');
  //       // a.href = url;
  //       // a.download = 'filename.pdf';
  //       // document.body.appendChild(a);
  //       // a.click();
  //       // document.body.removeChild(a);
  //       // window.URL.revokeObjectURL(url);
  //       // pdfMake.createPdf(resp).download('NOC_BILL.pdf');

  //     }
  //   } catch (error) {
  //     console.error('Error downloading PDF:', error);
  //   }
  // }
  pdf_flag: boolean = false
  async nocgeneration(element: any) {
    console.log(element);
    let obj: any = Object.assign({}, element)
    obj["b_acct_id"] = this.b_acct_id
    obj["status"] = 'LAST_LEVEL_APPROVED'
    obj["doc_type"] = ['ENGINEERING', 'PROPERTY', 'TAX']
    obj["check_st"] = 'VERIFYED'
    let resp: any = await this.clerkNocService.getprintdata(obj)
    console.log(resp);

    if (resp["error"] == false) {
      this.nocObj = resp.data
      this.dept_data = resp.dept
      // await this.sendmailtouser(this.nocObj)

      const documentDefinition: any = await this.printnocgen(element);
      // pdfMake.createPdf(documentDefinition).download('NOC_BILL.pdf')
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

      pdfDocGenerator.getBlob(async (blob: any) => {
        const emailData = {
          to: this.nocObj['email'],
          // subject: 'This will be initiated subject of the note sheet that have been started from LDA',
          subject: this.nocObj['subject'],
          content: `<h4>Dear User, </h4> <br> Please deposit the amount for the building map of 
            ${element.party_name}, located at ${element.address},  under
            Lucknow Development Authority's letter no.${element.lda_letter_number} dated ${moment(element.valid_from).format('DD.MM.YYYY')}. 
            Further the bifurcation of the amount required to deposit have given below: <br><br>
            You’re required to pay the amount ${this.nocObj.bill_amount} , for payment log into your account and follow the following path i.e., Login>>Select payment>>Enter amount >> Pay and make the payment so that we can proceed further. `
        };

        const formData = new FormData();
        // console.log(blob);

        formData.append('file', blob, 'NOC_BILL.pdf');
        formData.append('emailData', JSON.stringify(emailData));
        //  console.log(this.main.httpUrl2 + '/noc/file_details/sendpdf');

        const response: any = await this.http.post(this.main.httpUrl2 + '/noc/file_details/sendpdf', formData).toPromise();
        console.log('File sent successfully', response);
        if (response["error"] == false) {
          this.pdf_flag = true
          await this.printnocgen(element);
          Swal.fire("Success", "Successfully NOC Issue", 'success')
        }
      });
      await this.getAllTaskOfUser()
    }
    //  await this.printnocgen(element)
  }

  // async sendmailtouser(element:any){
  //   let obj = Object.assign({},element)
  //   const emailData = {
  //     to: 'ojhashweta1701@gmail.com',
  //     subject: 'This will be initiated subject of the note sheet that have been started from LDA',
  //     content: `<h4>Dear User, </h4> <br> 		Please deposit the amount for the building map of 
  //     ${element.party_name}, located at ${element.address}, Lucknow, under
  //      Lucknow Development Authority's letter no.${element.lda_letter_number} dated ${moment(element.valid_from).format('DD.MM.YYYY')}. 
  //      Further the bifurcation of the amount required to deposit have given below:`
  //   };

  //  let resp = await this.clerkNocService.sendmail(emailData)
  //  console.log(resp);

  // }
  // ////////////////////////////////////////////////print NOC Generation /////////////////////////////////////////////////////////



  async printnocgen(element: any) {
    let log = await this.clerkNocService.getlogophoto();
    let c = await this.blobToBase64(log);
    let noccerft = await this.clerkNocService.getnoccertifphoto();
    let cnoccerftphoto = await this.blobToBase64(noccerft);

    const txt = "No Objection Certificate(NOC)";
    const txtfooter = '';

    const objHeading1 = {
      text: txt, alignment: 'center', fontSize: 18, bold: true, style: 'header',
    };

    const dd: any = {
      pageSize: 'A4',
      footer: function (currentPage: any, pageCount: any) {
        return {
          columns: [
            { text: txtfooter + currentPage.toString() + ' of ' + pageCount, alignment: 'center', bold: true, style: 'header' }
          ]
        };
      },
      background: function (currentPage: any, pageSize: any) {
        return {
          image: c,
          width: 350,
          height: 350,
          opacity: 0.3,
          margin: [120, 200, 50, 10]
        };
      },
      pageOrientation: 'portrait',
      pageMargins: [15, 30, 15, 30],
      content: [
        { image: 'logo', width: 70, height: 69, alignment: 'center' },
        objHeading1,
        { text: "Nagar Nigam, Lucknow", alignment: 'center', fontSize: 10, bold: true, style: 'header' },
        { text: " " },
        {
          table: {
            widths: ['50%', '50%'],
            body: [
              [
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [{ text: 'Sender,', fontSize: 10, bold: true, alignment: 'left' }],
                      [{ text: `Chief Architect Municipal Corporation, Lucknow. No....Year/CTP/File Serial no ${element.file_number}`, fontSize: 10, alignment: 'left' }]
                    ]
                  },
                  layout: 'noBorders'
                },
                {
                  table: {
                    widths: ['*'],
                    body: [
                      [{ text: `To, `, fontSize: 10, bold: true, alignment: 'left' }],
                      [{ text: `User Name : ${element.party_name}`, fontSize: 10, alignment: 'left' }],
                      [{ text: `Address : ${element.address}`, fontSize: 10, alignment: 'left' }]
                    ]
                  },
                  layout: 'noBorders'
                }
              ]
            ]
          },
          layout: 'noBorders'
        },
        { text: " " },
        {
          text: 'Subject: ',
          style: 'texthead',
        },
        {
          text: element['subject'],
          style: 'normal'
        },
        {
          text: `Sir,`,
          style: 'texthead',

        },
        {
          text: `Please submit the building map of  ${element.party_name}, located at  ${element.address}, under Lucknow Development Authority\'s letter no. ${element.lda_letter_number} dated ${moment(element.valid_from).format('DD.MM.YYYY')} . Please try to take reference of. After testing at the Municipal Corporation level, the fee amount has been deposited by the applicant in the Municipal Corporation fund under the demand letter no. 100/Mu.Va./23 dated 19.12.23 issued for the following fee amount, which is effective.`,
          style: 'normal',
        },



      ],
      images: {
        logo: cnoccerftphoto
      },



      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
          color: 'black'
        },
        subheader: {
          fontSize: 14,
          bold: true,
          margin: [0, 10, 0, 5],
          color: '#00796B'
        },
        normal: {
          fontSize: 8,
          margin: [0, 5, 0, 5]
        },
        texthead: {
          fontSize: 10,
          margin: [0, 5, 0, 5],
          bold: true
        },
        list: {
          margin: [0, 5, 0, 5]
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        }
      }
    };
    var tbl: any = {
      fontSize: 10,
      table: {
        headerRows: 1,
        widths: [30, 40, 450],
        body: [
          [
            { text: 'Zone', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true },
            { text: 'Area of Plot', fontSize: 10, alignment: 'center', style: 'tableHeader', bold: true },
            { text: 'No objection is being given with the following conditions', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true },
          ],
          [
            { text: element.zone, alignment: 'left', fontSize: 8 },
            { text: element.total_area, fontSize: 8, alignment: 'left' },
            {
              ul: [
                'The construction of the building will be done as per the map approved by Lucknow Development Authority.',
                'There will be no encroachment on Municipal Corporation\'s land property, footpath, drain, road etc.',
                'Materials for building construction will not affect traffic.',
                'Disposal of building material remains will be done under the provisions of C&D Waste Management Rules 2016.',
                'During the construction of the building, if there is any damage on the footpath, road, drain etc., then it will be repaired by the building owner.'
              ],
              alignment: 'left',
              fontSize: 10
            },
          ],
        ]
      },
      layout: {
        hLineWidth: function (i: any, node: any) { return (i === 0 || i === node.table.body.length) ? 1 : (i === 1 ? 1 : 0); },
        vLineWidth: function (i: any, node: any) { return (i === 0 || i === node.table.widths.length) ? 1 : 1; },
        hLineColor: function (i: any, node: any) { return 'black'; },
        vLineColor: function (i: any, node: any) { return 'black'; }
      }
    }
    dd.content.push(tbl)
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    var tb2 = {
      fontSize: 10,
      table: {
        headerRows: 2,
        widths: [85, 85, 85, 85, 85, 85],
        body: [
          [
            { text: 'Cover Area', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, rowSpan: 2 },
            { text: 'Area of Plot', fontSize: 10, alignment: 'center', colSpan: 2, style: 'tableHeader', bold: true },
            {},
            { text: 'Area of Plot', alignment: 'center', fontSize: 10, colSpan: 2, style: 'tableHeader', bold: true },
            {},
            { text: 'Total Positive Number', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true, rowSpan: 2 },
          ],
          [
            {}, // Empty cell for the 'Cover Area' rowSpan
            { text: 'Receipt No. and\n Date', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true },
            { text: 'Positive No.', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true },
            { text: 'Receipt No. and\n Date', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true },
            { text: 'Positive No.', alignment: 'center', fontSize: 10, style: 'tableHeader', bold: true },
            {}, // Empty cell for the 'Total\n Positive\n Number' rowSpan
          ],
          [
            { text: this.nocObj.floor_buld_area, alignment: 'left', fontSize: 10 },
            { text: `${this.nocObj['bill_sh_id']}\n${moment(this.nocObj['bill_date']).format('YYYY-MM-DD')}`, fontSize: 8, alignment: 'left' },
            { text: `${this.nocObj['total_reinfor_fees']}`, fontSize: 8, alignment: 'left' },
            { text: `${this.nocObj['bill_sh_id']}\n${moment(this.nocObj['bill_date']).format('YYYY-MM-DD')}`, fontSize: 8, alignment: 'left' },
            { text: `${this.nocObj['total_reinfor_fees']}`, fontSize: 8, alignment: 'left' },
            { text: `${this.nocObj.bill_amount}`, fontSize: 8, alignment: 'left' },
          ],
        ]
      },
      layout: {
        hLineWidth: function (i: any, node: any) { return (i === 0 || i === node.table.body.length) ? 1 : (i === 1 ? 1 : 0); },
        vLineWidth: function (i: any, node: any) { return (i === 0 || i === node.table.widths.length) ? 1 : 1; },
        hLineColor: function (i: any, node: any) { return 'black'; },
        vLineColor: function (i: any, node: any) { return 'black'; }
      }
    };

    dd.content.push(tb2)
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    let prop_date = this.dept_data.find((item: any) => {
      if (item.doc_type == 'PROPERTY') {
        return item
      }
    })
    let tax_date = this.dept_data.find((item: any) => {
      if (item.doc_type == 'TAX') {
        return item
      }
    })
    let eng_date = this.dept_data.find((item: any) => {
      if (item.doc_type == 'ENGINEERING') {
        return item
      }
    })
    console.log(prop_date, tax_date, eng_date);

    let txt2 = `In compliance with the Property Department's report dated ${moment(prop_date['valid_from']).format('DD/MM/YYYY')}, Zonal Officer's report dated ${moment(tax_date['valid_from']).format('DD/MM/YYYY')}, Engineering Department's report dated ${moment(eng_date['valid_from']).format('DD/MM/YYYY')} \n and Additional Municipal Commissioner's approval dated 13.12.23, \nthe applicant was granted no objection for the covered area of ​​1135.00 square meters. \nThe Municipal Corporation has no objection. In case of increase in the area covered due to any kind of change/alteration in the said map from Lucknow Development Authority, \nfurther approval of the Municipal Corporation will be required.`

    var header2 = {
      text: txt2, alignment: 'left', fontSize: 8, style: 'normal'
    }
    dd.content.push(header2)
    dd.content.push({ text: " " });
    dd.content.push({ text: " " });
    let txt3 = `Chief Architect`

    var header3 = {
      text: txt3, alignment: 'right', fontSize: 12, bold: true, style: 'normal'
    }
    dd.content.push(header3)
    let txt4 = `Nagar Nigam, Lucknow`

    var header4 = {
      text: txt4, alignment: 'right', fontSize: 10
    }
    dd.content.push(header4)

    if (this.pdf_flag == true) {

      pdfMake.createPdf(dd).download('NOC_BILL.pdf');
    } else {
      return dd
    }
  }

  ///////////////////////////////////////////excle export///////////////////////////////////////////////////

  export() {
    const dataToExport = this.datasource.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


  export_appr_file() {
    const dataToExport = this.datasource_appr_file.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }

  export1() {
    const dataToExport = this.datasource1.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }
  export_bill_pay() {
    const dataToExport = this.billpay_datasource.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }
  export_verify() {
    const dataToExport = this.verifyed_datasource.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }
  exportchiefengapp() {
    const dataToExport = this.datasource_chief_eng_approved.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }
  exportchiefeng() {
    const dataToExport = this.datasource_chief_eng.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }

  exportrejectedbill() {
    const dataToExport = this.datasource_bill_reject.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,

      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'file');
  }


}
